var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "54DB424C-8AE0-4E36-8222-40DFDDEF8E18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "League-&-Fixtures",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "League-&-Fixtures-|-Final_EmptyScores-(Desktop)",
    transform: "translate(-1348.000000, -176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(750.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(20.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33-Copy",
    transform: "translate(570.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Go_arrow_White",
    transform: "translate(15.500000, 15.500000) scale(-1, 1) rotate(-180.000000) translate(-15.500000, -15.500000) translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_arrow-forward_2459676",
    transform: "translate(0.750000, 3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88020721,-0.0972882319 L8.98607904,-0.0777505132 C9.089695,-0.0490209738 9.18599929,0.00702204707 9.26357216,0.0869515038 L9.26357216,0.0869515038 L13.3797385,4.2687012 C13.4754195,4.35041996 13.5462128,4.46112896 13.5793708,4.58810441 C13.6025837,4.67699597 13.6058862,4.768272 13.5908961,4.85590841 L13.5908961,4.85590841 L13.586,4.855 L13.5786017,4.89807973 C13.5682284,4.94545486 13.5561351,4.98129649 13.5415817,5.01370017 L13.517814,5.06073915 L13.507,5.077 L13.5043385,5.08258689 L13.4975604,5.09290967 C13.4894497,5.10697214 13.4794298,5.12128766 13.4665812,5.13785617 L13.4665812,5.13785617 L13.4515842,5.15596928 L13.4422502,5.16690727 L13.4293577,5.1812385 L13.4166562,5.19454185 L9.26367869,9.41553229 C9.14748441,9.53392225 8.98961802,9.60021623 8.82526148,9.59999956 C8.69983838,9.59999956 8.58057264,9.56164453 8.48067515,9.49379533 C8.38116771,9.42621105 8.30087513,9.32934049 8.25305942,9.21200063 C8.2053839,9.09500482 8.19470972,8.96917437 8.2179963,8.85020461 C8.24131952,8.7310477 8.29869881,8.61880291 8.38692072,8.52913955 L8.38692072,8.52913955 L11.4863546,5.3780196 L0.519133028,5.37892038 C0.347980784,5.37892038 0.192955325,5.30853847 0.0807679069,5.19451377 C-0.030836352,5.08108177 -0.1,4.92441395 -0.1,4.75128554 C-0.1,4.57815713 -0.030836352,4.4214893 0.0807679069,4.30805731 C0.192955325,4.1940326 0.347980784,4.12365069 0.519127222,4.12365069 L0.519127222,4.12365069 L11.4863075,4.12301386 L8.38742086,0.973957511 C8.2298802,0.816050259 8.16743485,0.584465344 8.22421642,0.367025677 C8.25262879,0.258223185 8.30867728,0.161359556 8.38433642,0.0844504697 C8.46028583,0.00724632821 8.55599006,-0.0498573542 8.66342844,-0.078856511 C8.77107628,-0.107912202 8.88225636,-0.106537369 8.98607904,-0.0777505132 Z",
    id: "Combined-Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoArrowWhite);
export default __webpack_public_path__ + "static/media/go-arrow-white.e3391645ab437b9c83fab002eb902eb9.svg";
export { ForwardRef as ReactComponent };